export default __webpack_public_path__ + "static/media/Shake_placement-16.7f498dcc.png";